(function () {
  'use strict';

  function initSliders() {
    if (!window.SwiperReady) return;
    window.SwiperReady(function () {
      document.querySelectorAll('.pairs-well-block .swiper:not(.swiper-initialized)').forEach(function (el) {
        new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 10,
          autoHeight: true
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    const block = e.target.closest('.pairs-well-block');

    const trigger = e.target.closest('.pairs-well-block .pw-swatch-trigger');
    if (trigger) {
      trigger.closest('.pw-custom-swatch-dropdown').classList.toggle('is-open');
      return;
    }

    const swatchItem = e.target.closest('.pairs-well-block .pw-swatch-item');
    if (swatchItem) {
      const dropdown = swatchItem.closest('.pw-custom-swatch-dropdown');
      const indicator = dropdown.querySelector('.selected-swatch-indicator');
      dropdown.querySelectorAll('.pw-swatch-item').forEach((item) => item.classList.remove('is-selected'));
      swatchItem.classList.add('is-selected');
      indicator.style.background = swatchItem.getAttribute('data-swatch-bg');
      indicator.style.backgroundSize = 'cover';
      indicator.style.backgroundPosition = 'center';
      const hiddenSelect = dropdown.nextElementSibling;
      hiddenSelect.value = swatchItem.getAttribute('data-value');
      dropdown.classList.remove('is-open');
      hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    document.querySelectorAll('.pairs-well-block .pw-custom-swatch-dropdown.is-open').forEach(function (dropdown) {
      if (!block || !dropdown.contains(e.target)) dropdown.classList.remove('is-open');
    });
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.pairs-well-block .pairs-well-select')) return;

    const block = e.target.closest('.pairs-well-block');
    const card = e.target.closest('.pairs-well-card');
    const jsonScript = card.querySelector('.pairs-well-variant-json');
    if (!jsonScript) return;

    const currentOptions = Array.from(card.querySelectorAll('.pairs-well-select'), (select) => select.value);
    const variants = JSON.parse(jsonScript.textContent);
    const match = variants.find((variant) => variant.options.every((opt, index) => opt === currentOptions[index]));
    const btn = card.querySelector('.pairs-well-btn');
    const img = card.querySelector('.pairs-well-img');
    const inputId = card.querySelector('.pairs-well-final-id');
    const regularPriceEl = card.querySelector('.pw-regular-price');
    const comparePriceEl = card.querySelector('.pw-compare-price');

    if (!match) {
      btn.textContent = block.dataset.unavailableText;
      btn.disabled = true;
      btn.classList.add('disabled');
      return;
    }

    inputId.value = match.id;
    if (match.featured_image && img) img.src = match.featured_image;
    if (regularPriceEl) regularPriceEl.innerHTML = match.price;
    if (comparePriceEl) {
      if (match.compare_at_price) {
        comparePriceEl.innerHTML = match.compare_at_price;
        comparePriceEl.style.display = 'inline-block';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    btn.textContent = match.available ? block.dataset.addText : block.dataset.soldOutText;
    btn.disabled = !match.available;
    btn.classList.toggle('disabled', !match.available);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
  document.addEventListener('shopify:section:load', initSliders);
})();
